module.exports = __webpack_public_path__ + "static/img/cabinet12_6.42d6738a.gif";